<template>
  <footer class="bg-dark text-white">
    <div class="container p-4">
      <div class="row py-2 d-flex align-items-center">
        <div class="col-3 col-md-2 col-lg-1 pt-1">
          <img
            :src="$store.state.config.frontpoint + '/storage/europe-emblem.png'"
            class="img-fluid"
            height=""
            width=""
            alt="Youth group"
          />
        </div>
        <div class="col font-size-12">
          This project has received funding from the European Union’s Horizon
          2020 research and innovation programme under grant agreement No
          101004640.
          <br />
          The views and opinions expressed in this website are the sole
          responsibility of the author and do not necessarily reflect the views
          of the EC
        </div>
      </div>
    </div>
    <div class="bg-primary text-white">
      <div class="container px-4">
        <div class="row py-2 small">
          <div class="col-12 col-sm-8">
            <p class="text-sm-start text-center text-light mb-0 light-300">
              © piloted and moderated by
              <a
                href="https://newabc.eu/"
                class="text-white"
                title="Go to new abc site"
                >NEW ABC</a
              >
              .
            </p>
          </div>
          <div class="col-12 col-sm-4 text-center text-sm-end">
            <router-link
              :to="{ name: 'CookiesPolicy' }"
              custom
              v-slot="{ navigate }"
            >
              <a
                role="link"
                class="text-white"
                aria-current="page"
                @click="navigate"
                @keypress.enter="navigate"
              >
                Cookies Policy
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>
